var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "21",
        height: "14",
        viewBox: "0 0 21 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M1.50165 0.511719C0.672613 0.511719 0 1.18433 0 2.01337C0 2.48576 0.222119 2.93 0.600659 3.21468L7.40813 8.32029C7.76477 8.58621 8.25281 8.58621 8.60945 8.32029L10.4052 6.97506C11.1529 5.10426 12.8985 3.74339 14.9821 3.54004L15.4169 3.21468C15.7955 2.93 16.0176 2.48576 16.0176 2.01337C16.0176 1.18433 15.345 0.511719 14.5159 0.511719H1.50165ZM9.21011 9.12117C8.49682 9.65613 7.52075 9.65613 6.80747 9.12117L0 4.01556V10.5227C0 11.627 0.89786 12.5249 2.0022 12.5249H11.2686C10.4834 11.5739 10.011 10.3506 10.011 9.02106C10.011 8.84587 10.0204 8.6738 10.036 8.50174L9.21011 9.12117ZM20.022 9.02106C20.022 7.82627 19.5473 6.68042 18.7025 5.83558C17.8577 4.99074 16.7118 4.51611 15.517 4.51611C14.3222 4.51611 13.1764 4.99074 12.3316 5.83558C11.4867 6.68042 11.0121 7.82627 11.0121 9.02106C11.0121 10.2158 11.4867 11.3617 12.3316 12.2065C13.1764 13.0514 14.3222 13.526 15.517 13.526C16.7118 13.526 17.8577 13.0514 18.7025 12.2065C19.5473 11.3617 20.022 10.2158 20.022 9.02106ZM17.6225 7.66645C17.8164 7.86041 17.8164 8.17951 17.6225 8.37347L15.37 10.6259C15.176 10.8199 14.8569 10.8199 14.663 10.6259L13.4116 9.37457C13.2176 9.18061 13.2176 8.86151 13.4116 8.66754C13.6056 8.47358 13.9247 8.47358 14.1186 8.66754L15.0165 9.5654L16.9154 7.66645C17.1094 7.47248 17.4285 7.47248 17.6225 7.66645Z",
          fill: "#010A11",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }